<script>
import axios from "axios";
import Vue from 'vue';
import {clerkAttributes} from "../services/clerkHelper";
export default new Vue({
    methods: {
        async searchContent(query){
            var res = await axios.get("/?altTemplate=Search&query=" + query);
            return res.data;
        },
        searchProducts(query, predictive, filter){
            return new Promise((resolve)=>{
                Clerk.call(predictive ? "search/predictive" : "search/search", {
                    limit : predictive ? 5 : 100,
                    query : query,
                    filter : filter,
                    label : "Search results",
                    // attributes:["id","name", "url", "badgeSpar", "badgeTilbud", "price", "type", "shortText", "onlyInShops"], 
                     attributes:clerkAttributes, 
                }, (res)=>{
                    resolve(res.product_data);
                })
            });
        }
    },
})
</script>